import { registerJobResultActions } from '@/modules/jobs';
import { serieDetailAgenda } from '../detail/serieDetailAgenda';

/** JobType publikace seriálu (musí odpovídat BE `PublishSeriePlanFactory.JobType`). */
export const SERIE_PUBLISH_JOB_TYPE = 'venua-serie-publish';

/**
 * Registrace výsledkových akcí publikace seriálu do jobs modulu: „Otevřít seriál" u dokončeného
 * běhu otevře detail seriálu (z opaque contextData `{productId, serieId}`, které plní BE plan
 * factory). Volá composition vrstva (shell) při registraci agend — jobs modul o venua-planneru
 * nic neví, závislost vede jen tímto směrem.
 */
export function registerVenuaPlannerJobResultActions(): void {
  registerJobResultActions(SERIE_PUBLISH_JOB_TYPE, [
    {
      key: 'open-serie',
      labelKey: 'venua-planner:publish.openSerie',
      onActivate: ({ contextData, kernel }) => {
        const data = contextData as { productId?: string; serieId?: string } | null;
        if (!data?.productId || !data.serieId) return;
        // Stejný vzor jako osamostatněné otevření agendy (openModal + fresh stackId → floating okno).
        void kernel
          .openModal(serieDetailAgenda, { productId: data.productId, serieId: data.serieId })
          .then(() => {
            const layerId = kernel.getState().activeTopLayerId;
            if (layerId) kernel.setLayerStackId(layerId, `s_${crypto.randomUUID()}`);
          });
      },
    },
  ]);
}
